import {
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
} from "@heroicons/react/20/solid";
import { cn } from "helpers/classNames";
import {
  PreliminaryTransportSedelEmailStatus,
  TransportSedel,
  TransportSedelStatus,
} from "types/transportSedel.type";

type Props = {
  transportSedel: TransportSedel;
  className?: string;
};

export const PreliminaryEmailStatusBadge = ({
  transportSedel,
  className,
}: Props) => {
  const status = transportSedel.preliminaryEmailStatus;

  const baseClass =
    "inline-flex w-fit items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium";

  if (status === PreliminaryTransportSedelEmailStatus.Sent) {
    return (
      <span className={cn(baseClass, "bg-blue-100 text-blue-800", className)}>
        <CheckCircleIcon className="h-4 w-4" />
        Skickad
      </span>
    );
  }

  if (
    status ===
    PreliminaryTransportSedelEmailStatus.FailedDueToMissingEmailAddress
  ) {
    return (
      <span className={cn(baseClass, "bg-rose-100 text-rose-700", className)}>
        <XCircleIcon className="h-4 w-4" />
        Epostadress saknas
      </span>
    );
  }

  if (status === PreliminaryTransportSedelEmailStatus.FailedForOtherReason) {
    return (
      <span className={cn(baseClass, "bg-rose-100 text-rose-700", className)}>
        <XCircleIcon className="h-4 w-4" />
        Kunde inte skickas
      </span>
    );
  }

  // NotSent: innan avfärd är det bara ett väntläge, efter avfärd blev den aldrig skickad
  if (transportSedel.status === TransportSedelStatus.Created) {
    return (
      <span className={cn(baseClass, "bg-gray-100 text-gray-600", className)}>
        <ClockIcon className="h-4 w-4" />
        Skickas vid avfärd
      </span>
    );
  }

  return (
    <span className={cn(baseClass, "bg-gray-100 text-gray-600", className)}>
      Ej skickad
    </span>
  );
};
